import { getEventType } from './eventTypes'

interface EventBadgeProps {
  type: string
  size?: 'sm' | 'md'
  index?: string | number
}

export function EventBadge({ type, size = 'sm', index }: EventBadgeProps) {
  const t = getEventType(type)
  const h = size === 'sm' ? 22 : 26
  const fs = size === 'sm' ? 11 : 12
  const dotSize = size === 'sm' ? 7 : 8
  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 6,
        height: h,
        padding: `0 ${size === 'sm' ? 8 : 10}px`,
        borderRadius: 999,
        background: t.soft,
        color: t.color,
        fontSize: fs,
        fontWeight: 600,
        fontFamily: 'Geist, sans-serif',
        whiteSpace: 'nowrap',
        letterSpacing: '0.005em',
      }}
    >
      <span
        style={{
          width: index ? 15 : dotSize,
          height: index ? 15 : dotSize,
          borderRadius: '50%',
          background: t.color,
          flexShrink: 0,
          color: '#fff',
          textAlign: 'center',
        }}
      >
        {index ? index : ''}
      </span>
      {t.label}
    </span>
  )
}

interface EventDotProps {
  type: string
  size?: number
}

export function EventDot({ type, size = 8 }: EventDotProps) {
  const t = getEventType(type)
  return (
    <span
      style={{
        width: size,
        height: size,
        borderRadius: '50%',
        background: t.color,
        display: 'inline-block',
        flexShrink: 0,
      }}
    />
  )
}

interface TypePillProps {
  type?: string
  label: string
  active: boolean
  onClick: () => void
}

export function TypePill({ type, label, active, onClick }: TypePillProps) {
  const t = type ? getEventType(type) : null
  return (
    <button
      onClick={onClick}
      className="type-pill"
      aria-label={label}
      aria-pressed={active}
      style={{
        background: active ? (t ? t.soft : 'var(--primary-soft)') : 'transparent',
        color: active ? (t ? t.color : 'var(--primary)') : 'var(--ink-2)',
        borderColor: active ? (t ? t.color : 'var(--primary)') : 'var(--line)',
      }}
    >
      {t && (
        <span
          style={{
            width: 8,
            height: 8,
            borderRadius: '50%',
            background: active ? t.color : t.soft,
            flexShrink: 0,
          }}
        />
      )}
      {label}
    </button>
  )
}
